import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5e04df5d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "invoice" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "gray" }, null, -1))
const _hoisted_4 = {
  key: 0,
  class: "screen"
}
const _hoisted_5 = { class: "time" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "start" }, "起止时间", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "end" }, "至", -1))
const _hoisted_8 = { class: "type" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "start" }, "订单类型", -1))
const _hoisted_10 = {
  key: 4,
  class: "page-contents"
}
const _hoisted_11 = { class: "page-tips" }

import { ref, onMounted, watch } from "vue"
import NoApply from "./NoApply.vue"
import NoApplyFirst from "./NoApplyFirst.vue"
import InvoiceSet from "./InvoiceSet.vue"
import useList from "@/lib/hooks/useList/index"
import { OptionsType } from "@/lib/hooks/useList/types"
import PageShowNumber from "@/components/common/PageShowNumber.vue"
import { userApi } from "@/service/api"
interface ItemType {}

interface informationType {
  start: number
  end: number
  type: number
  status1: number
}

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

let information = ref<informationType>({
  start: 0,
  end: 0,
  type: 0,
  status1: 1,
})
let isShow = ref(true)
watch(
  [information],
  () => {
    loadData()
  },
  { deep: true }
)

let modifyInformation = (information: informationType) => {
  let invoiceType = []
  if (information.type == 0) {
    invoiceType = [1, 6]
  } else if (information.type == 1) {
    invoiceType = [1]
  } else {
    invoiceType = [6]
  }
  return {
    uid: "",
    start: information.start / 1000,
    end: information.end / 1000,
    type: invoiceType,
    status1: information.status1,
  }
}

let whereInformation = ref<informationType>({
  start: 0,
  end: 0,
  type: 0,
  status1: 1,
})
// 交易记录的信息
let Options: OptionsType<informationType> = {
  filterOption: information,
  preRequest: modifyInformation,
}

let handleCurrentChange = (val: number) => {
  curPage.value = val
}

const { list, loading, reset, curPage, pageSize, total, loadData } = useList<
  any,
  any
>(userApi.getAccounts, Options, () => {})

let change = (val: number) => {
  whereInformation.value.status1 = val
  information.value = { ...whereInformation.value }
}
let editChange = () => {
  loadData()
}

onMounted(() => {
  loadData()
})

return (_ctx: any,_cache: any) => {
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(change)(1))),
        class: _normalizeClass({ active: _unref(information).status1 == 1 })
      }, " 待申请 ", 2),
      _createElementVNode("div", {
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(change)(2))),
        class: _normalizeClass({ active: _unref(information).status1 == 2 })
      }, " 待开票 ", 2),
      _createElementVNode("div", {
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(change)(3))),
        class: _normalizeClass({ active: _unref(information).status1 == 3 })
      }, " 已寄出 ", 2),
      _createElementVNode("div", {
        onClick: _cache[3] || (_cache[3] = ($event: any) => (_unref(change)(4))),
        class: _normalizeClass({ active: _unref(information).status1 == 4 })
      }, " 发票设置 ", 2)
    ]),
    _hoisted_3,
    (_unref(information).status1 != 4)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createVNode(_component_el_form_item, { prop: "startTime" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, { span: 24 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_date_picker, {
                      modelValue: _unref(information).start,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(information).start) = $event)),
                      type: "date",
                      placeholder: "开始日期",
                      style: {"width":"100%"},
                      format: "YYYY/MM/DD",
                      "value-format": "x",
                      clearable: "false"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _hoisted_7,
            _createVNode(_component_el_form_item, {
              prop: "endTime",
              class: "last-form-item"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, { span: 24 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_date_picker, {
                      modelValue: _unref(information).end,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(information).end) = $event)),
                      type: "date",
                      placeholder: "结束日期",
                      style: {"width":"100%"},
                      format: "YYYY/MM/DD",
                      "value-format": "x"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            _createVNode(_component_el_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: _unref(information).type,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(information).type) = $event)),
                  placeholder: "选择订单类型",
                  class: "type-box"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_option, {
                      label: "全部",
                      value: 0
                    }),
                    _createVNode(_component_el_option, {
                      label: "充值",
                      value: 1
                    }),
                    _createVNode(_component_el_option, {
                      label: "备件",
                      value: 2
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            })
          ])
        ]))
      : _createCommentVNode("", true),
    (_unref(information).status1 == 1)
      ? (_openBlock(), _createBlock(NoApplyFirst, {
          key: 1,
          "account-list": _unref(list),
          onEditChange: _unref(editChange),
          loading: _unref(loading)
        }, null, 8, ["account-list", "onEditChange", "loading"]))
      : (_unref(information).status1 < 4)
        ? (_openBlock(), _createBlock(NoApply, {
            key: 2,
            "account-list": _unref(list),
            loading: _unref(loading),
            onEditChange: _unref(editChange)
          }, null, 8, ["account-list", "loading", "onEditChange"]))
        : _createCommentVNode("", true),
    (_unref(isShow) && _unref(information).status1 == 4)
      ? (_openBlock(), _createBlock(InvoiceSet, { key: 3 }))
      : _createCommentVNode("", true),
    (_unref(total) > 0 && _unref(isShow))
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _createElementVNode("p", _hoisted_11, " 共" + _toDisplayString(_unref(total)) + "条，每页显示" + _toDisplayString(_unref(pageSize)) + "条，第" + _toDisplayString(_unref(curPage)) + "/" + _toDisplayString(Math.ceil(_unref(total) / _unref(pageSize))) + "页 ", 1),
          _createVNode(PageShowNumber, {
            pageSize: _unref(pageSize),
            total: _unref(total),
            pageIndex: _unref(curPage),
            onHandleCurrentChange: _unref(handleCurrentChange)
          }, null, 8, ["pageSize", "total", "pageIndex", "onHandleCurrentChange"])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})